import React from 'react';
import ReactQueryParams from "react-query-params";
import {Col, Button, Row, Card, CardBody,Badge,ButtonToolbar} from 'reactstrap';

import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import * as http from '../../../modules/http';
import Alert from '../../../components/Alert';
import CheckBox from "../../../components/CheckBox";
import Modal from './Modal'
import Modal2 from '../../../components/Modal'

import {fetchSalesDataIfNeeded} from "../../../redux/actions/SalesActions";

class OrderForm extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            warning: '',
            error: false,
            saved: false,
            success: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchSalesDataIfNeeded());
    }

    chooseProvider = (id, e) => {
        let tmp = this.state.order.split(',');

        if (e === true) {
            if (!tmp.includes(id.toString())) {
                let ids = this.state.order;
                if (ids === "")
                    this.setState({order: id.toString()});
                else
                    this.setState({order: ids.concat("," + id.toString())});
            }
        }
        else {
            if (tmp.includes(id.toString())) {
                let res = "";
                let idString = id.toString();
                for (let index in tmp) {
                    if (idString !== tmp[index]) {
                        if (res === "")
                            res += tmp[index];
                        else
                            res += "," + tmp[index];
                    }
                }

                this.setState({order: res});
            }
        }
    };

    sendOrder = () => {

        if(this.state.order === '') {
            this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectProvider});
            return;
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            storeId: this.props.userData.data.id,
            order: this.state.order
        };

        http.postToServer(
            'order/new',
            storeData,
            (response) => {
                this.setState({saving: false, error: false, success: true, order: ''});
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );
    };

    render() {

        let providers = [];

        if(this.props.data) {
            providers = this.props.data;
        }

        let chosenAcc = this.state.order.split(',');

        /*return(
            <Card>
                <CardBody>
                    <div className="catalog-items__wrap">
                        <div className="catalog-items">
                            {providers.map((item, i) =>
                                (
                                    <div className="catalog-item" key={i}>
                                        <Link className="catalog-item__link" to={{ pathname: `/sales/${item.id}`, state: { name: item.name, id: item.id}}} style={{padding: '20px 20px'}}>
                                            <div className="catalog-item__img-wrap">
                                                <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                     src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                            </div>
                                            <div className="catalog-item__info">
                                                <h5 className="catalog-item__title">{item.name}</h5>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                        </div>
                    </div>
                </CardBody>
            </Card>
        )*/


        return(

            <div className="catalog-items__wrap">
                {this.state.warning !== '' &&
                <Row >
                    <Alert color='warning' className='alert--bordered' icon >
                        <p><span style={{float: 'right'}}
                            className='bold-text'>{this.state.warning}</span>
                        </p>
                    </Alert>
                </Row>}
                {this.state.error &&
                    <Row>
                        <Alert color='danger' className='alert--bordered' icon>
                            <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                            <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                        </Alert>
                    </Row>
                }
                {this.state.success &&
                <Modal2 color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                       message={TextManager.getCurrentTextResource().Text.orderSucceeded}
                       approve={() => this.setState({saved: true, success: false})}/>
                }
                <div className="catalog-items" style={{flexDirection: 'row-reverse'}}>
                    {providers.map((item, i) => {
                        let res = chosenAcc.includes((item.id).toString());
                        return (
                            <div className="catalog-item" key={i} style={{padding: '20px 20px', height: '160px'}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                </div>
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title">{item.name}</h5>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    <CheckBox
                                        name={item.name}
                                        value={res}
                                        onChange={(e) => this.chooseProvider(item.id, e)}/>
                                </div>
                            </div>
                        )})
                    }
                </div>

                <Modal color='primary' title='Are you sure!'
                       approve={() => this.sendOrder()}
                       message={'?' + TextManager.getCurrentTextResource().Text.makeOrder}>
                    <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse'}}>
                        <Button color='primary' onClick={(e) => e.preventDefault()}>
                            {TextManager.getCurrentTextResource().Text.makeOrder}
                        </Button>
                    </ButtonToolbar>
                </Modal>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.sales.data,
        status: state.sales.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(OrderForm))